$(document).ready(function(){
  $('.desktop-filters-btn').on('click', function(){
      $(this).toggleClass('active-button');
      $('#desktop-filters').toggleClass('hide-filters');
      $('.main-collection-page').toggleClass('mobile-main-collection-page');
      $('.collection-grid-row').toggleClass('hide-filters-collection-grid-row');
  }); 
}); 
 
$(document).ready(function(){
  const customerDropdownBtn = $('[aria-controls="customer-dropdown"],[aria-controls="customer-login-dropdown"]')
  const customerDropdown = $('#customer-dropdown,#customer-login-dropdown');
  
  function handleCustomerMenuOutsideClick(e) {
    // If the click was outside the toggle button & the dropdown close the dropdown
    if ((!customerDropdownBtn.has(e.target).length) && (!customerDropdown.has(e.target).length)) {
      toggleCustomerMenu()
    }
  };
  
  function toggleCustomerMenu() {
    if (customerDropdown.hasClass('active')) {
      customerDropdown.removeClass('active');
      $(document).off('click', handleCustomerMenuOutsideClick)
    } else {
      customerDropdown.addClass('active');
      $(document).on('click', handleCustomerMenuOutsideClick);
    }
  };

  // Button click par dropdown toggle karo
  customerDropdownBtn.on('click', toggleCustomerMenu);
  // Escape key press hone par dropdown close karo
  $(document).on('keydown', function(e) {
    if (e.key === "Escape") {
      if (customerDropdown.hasClass('active')) {
        toggleCustomerMenu();
      }
      $('.close-btn-popup').trigger('click');
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  // Check if the page has been scrolled after reload
  if (window.scrollY > 0) {
      document.body.classList.add("scrolled");
  } 

  // Add a scroll event listener
  window.addEventListener("scroll", function() {
      // Add class when scrolled down
      if (window.scrollY > 50) {
          document.body.classList.add("scrolled");
      }
      // Remove class when scrolled back to the top
      else {
          document.body.classList.remove("scrolled");
      }
  });
});

$(document).ready(function() {
  // Initialize the slick slider with vertical settings
  $('.banner_slider').slick({
    vertical: true,
    infinite: true,    // Infinite loop
    slidesToShow: 2,   // How many items to show at once
    slidesToScroll: 4, // Scroll 4 items at a time
    autoplay: true,    // Enable autoplay
    autoplaySpeed: 800, // Time between slide transitions (2000ms = 2 seconds)
    speed: 3500,        // Speed of transition (2000ms = 2 seconds)
    pauseOnHover: false, // Disable pause on hover
    arrows: false,     // Disable arrows (not needed for slot machine)
    responsive: [
      {  
        breakpoint: 989,
        settings: {
          slidesToShow: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]

  });

});

$(document).ready(function() {
    $('.home-collection-tab .tabs-menu a').on('click', function(event) {
      event.preventDefault();
      
      // Remove active class from tabs and content
      $('.home-collection-tab .tabs-menu .tab-item').removeClass('active');
      $('.home-collection-tab .tab-content').removeClass('active');
  
      // Add active class to clicked tab and corresponding content
      $(this).parent().addClass('active');
      var target = $(this).attr('href');
      $(target).addClass('active');
    });
  });  

  $(document).on('click', '.show-news-letter', function() {
    $('.exclusive-deals-newsletter').addClass('active');
});

  $(document).ready(function() {
    setTimeout(function() {
        $('.main-site-faq > li:first-child h3 > button').trigger('click');
    }, 500); // You can adjust the delay time (in milliseconds) if necessary
}); 


document.addEventListener('DOMContentLoaded', function() {
  const submenuToggles = document.querySelectorAll('.submenu-toggle');
  
  submenuToggles.forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      const menuItem = toggle.closest('.menu-item');
      menuItem.classList.toggle('active'); // Add 'active' class to toggle submenu
    });
  });
});

$(document).ready(function() {
  // Check if any submenu link has the .active class
  $('.submenu-link.active').closest('.has-dropdown').addClass('menu-open');
});
  

function debounce(func, wait) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
  
window.onload = debounce(function() {
  // Check if the #splide-recently exists on the page
  var splideRecentlyElement = document.querySelector('#splide-recently');
  if (splideRecentlyElement) {
    var splideRecently = new Splide('#splide-recently', {
      type      : 'loop',
      perPage   : 4,
      perMove   : 1,
      gap       : '20px',
      focus     : 0,
      arrows    : true,
      drag      : true,
      pagination: true,
      classes   : {
        arrows: 'splide__arrows',
        arrow : 'splide__arrow',
        prev  : 'splide__arrow--prev',
        next  : 'splide__arrow--next',
      },
      breakpoints: {
        1024: { perPage: 3 },
        768 : { perPage: 2 },
        480 : { perPage: 2 },
      },
    });

    // Progress bar for Recently Viewed Slider
    splideRecently.on('mounted move', function() {
      var bar = document.querySelector('#splide-recently .splide__progress__bar');
      var end = splideRecently.Components.Controller.getEnd() + 1;
      var rate = Math.min((splideRecently.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    });

    // Mount the Recently Viewed Slider
    splideRecently.mount();
  }

  // Check if the #splide-related exists on the page
  var splideRelatedElement = document.querySelector('#splide-related');
  if (splideRelatedElement) {
    var splideRelated = new Splide('#splide-related', {
      type      : 'loop',
      perPage   : 4,
      perMove   : 1,
      gap       : '20px',
      focus     : 0,
      arrows    : true,
      drag      : true,
      pagination: true,
      breakpoints: {
        1024: { perPage: 3 },
        768 : { perPage: 2 },
        480 : { perPage: 2 },
      },
    });
 
    // Progress bar for Related Products Slider
    splideRelated.on('mounted move', function() {
      var bar = document.querySelector('#splide-related .splide__progress__bar');
      var end = splideRelated.Components.Controller.getEnd() + 1;
      var rate = Math.min((splideRelated.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    });

    // Mount the Related Products Slider
    splideRelated.mount();
  }

  // Check if the #soon-out-of-stock exists on the page
  var splideSoonOutOfStockElement = document.querySelector('#soon-out-of-stock-slider');
  if (splideSoonOutOfStockElement) {
    var splideSoonOutOfStock = new Splide('#soon-out-of-stock-slider', {
      type      : 'loop',
      perPage   : 4,
      perMove   : 1,
      gap       : '20px',
      focus     : 0,
      arrows    : true,
      drag      : true,
      pagination: true,
      breakpoints: {
        1024: { perPage: 3 },
        768 : { perPage: 2 },
        480 : { perPage: 2 },
      },
    });

    // Progress bar for Soon Out of Stock Slider
    splideSoonOutOfStock.on('mounted move', function() {
      var bar = document.querySelector('#soon-out-of-stock-slider .splide__progress__bar');
      var end = splideSoonOutOfStock.Components.Controller.getEnd() + 1;
      var rate = Math.min((splideSoonOutOfStock.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    });
 
    // Mount the Soon Out of Stock Slider
    splideSoonOutOfStock.mount();
  }


  // Check if the #soon-out-of-stock exists on the page
  var splideDropElement = document.querySelector('#dorp-slider');
  if (splideDropElement) {
    var splideDrop = new Splide('#dorp-slider', {
      type      : 'loop',
      perPage   : 4,
      perMove   : 1,
      gap       : '20px',
      focus     : 0,
      arrows    : true,
      drag      : true,
      pagination: true,
      breakpoints: {
        1024: { perPage: 3 },
        768 : { perPage: 1 },
        480 : { perPage: 1 },
      },
    });
    // Mount the Soon Out of Stock Slider
    splideDrop.mount();
  }

 
  // Check if the #soon-out-of-stock exists on the page
  var splideWholesaleElement = document.querySelector('#splide-wholesale');
  if (splideWholesaleElement) {
    var splideWholesale = new Splide('#splide-wholesale', {
      type      : 'loop',
      perPage   : 3,
      perMove   : 1,
      gap       : '35px',
      focus     : 0,
      arrows    : true,
      drag      : true,
      pagination: true,
      breakpoints: {
        1024: { perPage: 3 },
        989 : { perPage: 2 },
        480 : { perPage: 1 },
      },
    });
    // Mount the Soon Out of Stock Slider
    splideWholesale.mount();
  }

   // Check if the #soon-out-of-stock exists on the page
   var splideContentslideElement = document.querySelector('#content-slider');
   if (splideContentslideElement) {
     var splideContentslide = new Splide('#content-slider', {
       type      : 'slide',
       perPage   : 1,
       perMove   : 1,
       gap       : '0px',
       focus     : 0,
       arrows    : true,
       drag      : true,
       pagination: true,
       breakpoints: {
         1024: { perPage: 1 },
         989 : { perPage: 1 },
         480 : { perPage: 1 },
       },
     });
     // Mount the Soon Out of Stock Slider
     splideContentslide.mount();
   }
  

    // Check if the #soon-out-of-stock exists on the page
    var splideTextslideElement = document.querySelector('#text-slider');
    if (splideTextslideElement) {
      var splideTextslide = new Splide('#text-slider', {
        type      : 'loop',
        perPage   : 4,
        perMove   : 1,
        gap       : '12px',
        focus     : 0,
        arrows    : true,
        drag      : true,
        pagination: true,
        breakpoints: {
          1550: { perPage: 3 },
          1024: { perPage: 3 },
          989 : { perPage: 2 },
          480 : { perPage: 1 },
        },
      });
      // Mount the Soon Out of Stock Slider
      splideTextslide.mount();
    }

}, 200);  // Debounce for 200ms
 
 
$(document).ready(function() {
  // Function to apply or remove the list view classes
  function applyListView() {
      $('ul.grid, .collection-container, .main-product-card').addClass('list-view-active');
      $('.list-view-btn').addClass('active'); // Add active class to the list view button
      $('.grid-view-btn').removeClass('active'); // Remove active class from the grid view button
      localStorage.setItem('view', 'list');
  }

  function removeListView() {
      $('ul.grid, .collection-container, .main-product-card').removeClass('list-view-active');
      $('.grid-view-btn').addClass('active'); // Add active class to the grid view button
      $('.list-view-btn').removeClass('active'); // Remove active class from the list view button
      localStorage.setItem('view', 'grid');
  }

  // Check local storage and apply the appropriate view on page load
  if (localStorage.getItem('view') === 'list') {
      //applyListView();
  } else {
      //removeListView(); // Default to grid view
  }

  // On click of the list view button
  $('.list-view-btn').on('click', function() {
      //applyListView();
  });

  // On click of the grid view button
  $('.grid-view-btn').on('click', function() {
      //removeListView();
  });
});


$(document).ready(function() {
  $('.mobile-menu-head').click(function() {
    $(this).toggleClass('active-menu-head');
    $(this).next('.mobile-menu-body').slideToggle();
  });
});

$(".smothscroller").click(function() {
  $('html,body').animate({
      scrollTop: $("#main-bazaar-team").offset().top},
      'slow');
});
   

  
// Run the function every 3 seconds
// setInterval(calculateTotalQuantity, 1000);
 
    $(document).on('click', '.mobile-menu-open', function() {
      var interval = setInterval(function() {
          var menu = $('.mobile-menu-categories');
          
          // Check if the menu is hidden, and then apply styles
          if (menu.css('display') === 'none') {
              menu.css({
                  'display': 'block',
                  'height': 'auto'
              });
          } else {
              clearInterval(interval); // Clear the interval once the styles are applied
          }
      }, 100); // Check every 100ms
  });
  
  let usingKeyboard = false;
  window.addEventListener('keydown', function (e) {
    if (e.key === 'Tab') {
      document.body.classList.add('show-focus-outline');
      usingKeyboard = true;
    }
  });

  window.addEventListener('mousedown', function () {
    if (usingKeyboard) {
      document.body.classList.remove('show-focus-outline');
      usingKeyboard = false;
    }
  });
     

  setTimeout(function () {
    $('.recently-viewed-products li.handle-recent-pro').each(function () {
        var $this = $(this);

        if ($this.find('.main-product-card').length > 0) {
            $this.addClass('recently-active');
        }

        if ($this.find('.empty-product-sec').length > 0) {
            $this.addClass('recently-empty');
        }
    });
}, 1000); // 1000 milliseconds = 1 second



$(document).ready(function() {
  if (window.location.hash === "#onborded-signup") {
    setTimeout(function() {
      $('.onboarding_form').trigger('click');

      // Remove the hash from URL after triggering
      history.replaceState(null, null, window.location.pathname);
    }, 1000); // 1 second delay
  }
});


